var map = {
	"./admin/reducer.js": 703,
	"./album/reducer.js": 704,
	"./announcement/reducer.js": 705,
	"./attendance/reducer.js": 706,
	"./class/reducer.js": 707,
	"./customer/reducer.js": 708,
	"./homework/reducer.js": 709,
	"./organization/reducer.js": 710,
	"./posts/reducer.js": 711,
	"./resource/reducer.js": 712,
	"./school/reducer.js": 904,
	"./serverTime/reducer.js": 713,
	"./sessions/reducer.js": 714,
	"./teacher/reducer.js": 715,
	"./user/reducer.js": 716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 702;